<template>
  <section id="Renewing">
    <div id="RenewingAnchor" />
    <b-container>
      <div class="left">
        <div class="title-box dark-bg">
          <div class="title">Extend Your<span>Agreement</span>in 4 Easy Steps!</div>
          <div class="underline"></div>
        </div>
        <div class="points">
          <div class="point">
            <div class="number">1</div>
            <p>Click on Extend Now in the menu located in the top left hand corner</p>
          </div>
          <div class="point">
            <div class="number">2</div>
            <p>Review the pricing and term options</p>
          </div>
          <div class="point">
            <div class="number">3</div>
            <p>Select agreement term: 2-, 4- or 6-Year License Term</p>
          </div>
          <div class="point">
            <div class="number">4</div>
            <p>Type in your e-signature and click Extend Now</p>
          </div>
        </div>
        <h4>We thank you for your continued support and look forward to having you as a United Club Seat Holder for many years to come.</h4>
      </div>
    </b-container>
  </section>
</template>

<script>
  export default {
    name: "Renewing",
  }
</script>

<style lang="scss" scoped>
  #Renewing {
    position: relative;
    background: url("~@/assets/bg/bg-renew.png") scroll no-repeat top right #092244;
    background-size: cover;
    width: 100%;
    padding: 65px 0 60px;
    #RenewingAnchor {
      position: absolute;
      top: 0;
      left: 0;
    }
    .container {
      display: flex;
      width: 100%;
      max-width: 1000px;
      flex-direction: row;
      @media (max-width: $md) {
        flex-direction: column;
      }
      .left {
        display: flex;
        width: 100%;
        flex-direction: column;
        z-index: 3;
        @media (max-width: $md) {
          width: 100%;
        }
        .title-box {
          width: 100%;
          &.dark-bg {
            .title {
              color: $orange;
              span {
                color: $white;
              }
            }
            .underline {
              background: #021734;
              &.full {
                max-width: 100%;
              }
            }
          }
          &.orange-bg {
            .title {
              color: $white;
              span {
                color: $blue;
              }
            }
            .underline {
              background: #C43A00;
            }
          }
          &.renewal-offer {
            margin-bottom: 50px;
          }
          .title {
            z-index: 2;
            position: relative;
            text-align: left;
            font-size: 22px;
            @include nofex;
            line-height: 31px;
            text-transform: uppercase;
            color: #FF4B00;
            span {
              position: relative;
              display: block;
              font-size: 58px;
              @include nexaBold;
              line-height: 1;
              color: #092244;
            }
          }
          .plan-info {
            max-width: 560px;
            margin: 20px 0 10px;
            p {
              font-size: 14px;
              @include nexaBold;
              line-height: 18px;
              text-align: left;
              color: $white;
              a {
                text-decoration: underline;
                color: $white;
              }
            }
          }
          .underline {
            width: 100%;
            max-width: 470px;
            margin-top: 20px;
            height: 6px;
          }
        }
        h4 {
          margin-top: 25px;
          max-width: 470px;
          @include nexaBold;
          font-size: 14px;
          line-height: 21px;
          color: $white;
        }
        .points {
          display: flex;
          flex-direction: column;
          max-width: 620px;
          margin-top: 48.3px;
          .point {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            margin-bottom: 15px;
            width: 100%;
            gap: 20px;
            &:last-child {
              margin-bottom: 0;
            }
            .number {
              display: flex;
              justify-content: center;
              @include nofex;
              font-size: 17px;
              line-height: 19px;
              width: 20px;
              min-width: 20px;
              padding-top: 1px;
              text-align: center;
              color: $orange;
            }
            p {
              max-width: 490px;
              @include nexaBold;
              font-size: 14px;
              line-height: 21px;
              color: $white;
            }
          }
        }
      }
    }
  }
</style>